import { BaseFormField } from "../Typings/Campaigns";

const defaultFormFieldOrder: Record<string, number> = {
  interestPicker: 0,
  optIn: 1,
  firstName: 2,
  lastName: 3,
  email: 4,
  phone: 5,
  location: 6,
  uploadResume: 7,
  areaOfInterest: 8,
};

const defaultJATNFormFieldOrder: Record<string, number> = {
  email: 0,
  interestPicker: 1,
  optIn: 2,
  firstName: 3,
  lastName: 4,
  phone: 5,
  location: 6,
  uploadResume: 7,
  areaOfInterest: 8,
};

const dateAddedFormField = {
  label: "Date Added",
  fieldName: "Date Added",
  dropdownOptions: [],
  enabled: true,
  fieldType: "date",
  fieldTypeLabel: "Date",
  required: false,
  textLength: "0",
  order: 0,
  isSearchable: true,
  archived: false,
  adGroupOptions: [],
  key: "date_added",
} as BaseFormField;

const phoneFormField = {
  label: "Phone Number",
  fieldName: "Phone Number",
  dropdownOptions: [],
  enabled: true,
  fieldType: "phone",
  fieldTypeLabel: "Phone Number",
  required: true,
  textLength: "0",
  order: 5,
  isSearchable: true,
  archived: false,
  adGroupOptions: [],
  key: "phone_number",
} as BaseFormField;

const emailFormField = {
  label: "Email Address",
  fieldName: "Email Address",
  dropdownOptions: [],
  enabled: true,
  fieldType: "email",
  fieldTypeLabel: "Email Address",
  required: true,
  textLength: "0",
  order: 4,
  isSearchable: true,
  archived: false,
  adGroupOptions: [],
  key: "email_address",
} as BaseFormField;

export {
  defaultFormFieldOrder,
  defaultJATNFormFieldOrder,
  dateAddedFormField,
  phoneFormField,
  emailFormField,
};
